import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Stories from './pages/Stories';
import Analytics from './pages/Analytics';
import Audiences from './pages/Audiences';
import AutomatedStories from './pages/AutomatedStories';
import AutomatedStoriesV2 from './pages/AutomatedStoriesV2';
import DataIntelligence from './pages/DataIntelligence';
import Settings from './pages/Settings';
import UsersPage from './pages/UsersPage';
import LoginPage from './pages/LoginPage';
import PendingAccessPage from './pages/PendingAccessPage';
import RejectedAccessPage from './pages/RejectedAccessPage';
import FeedsPage from './pages/FeedsPage';
import FeedsSourcesPage from './pages/FeedsSourcesPage';
import FeedsSourceDetailPage from './pages/FeedsSourceDetailPage';
import SitePublicationsPage from './pages/SitePublicationsPage';
import FeedsPublicationDetailPage from './pages/FeedsPublicationDetailPage';
import FeedsItemsPage from './pages/FeedsItemsPage';
import FeedsItemDetailPage from './pages/FeedsItemDetailPage';
import './App.css';
import MediaPage from './pages/MediaPage';
import InferencePage from './pages/InferencePage';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[#0a0e1a] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-slate-400">Loading Okebourne...</p>
      </div>
    </div>
  );
}

function ProtectedRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="stories" element={<Stories />} />
        <Route path="stories/:id" element={<Stories />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="audiences" element={<Audiences />} />
        <Route path="automated" element={<AutomatedStoriesV2 />} />
        <Route path="automated-legacy" element={<AutomatedStories />} />
        <Route path="intelligence" element={<DataIntelligence />} />
        <Route path="intelligence/:id" element={<DataIntelligence />} />
        <Route path="settings" element={<Settings />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="inference" element={<InferencePage />} />
        
        <Route path="feeds"                          element={<FeedsPage />} />
        <Route path="feeds/sources"                  element={<FeedsSourcesPage />} />
        <Route path="feeds/sources/:sourceId"        element={<FeedsSourceDetailPage />} />
        <Route path="feeds/publications"             element={<SitePublicationsPage />} />
        <Route path="feeds/publications/:pubId"      element={<FeedsPublicationDetailPage />} />
        <Route path="feeds/items"                    element={<FeedsItemsPage />} />
        <Route path="feeds/items/:itemId"            element={<FeedsItemDetailPage />} />
        <Route path="media" element={<MediaPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />

      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/pending" element={<PendingAccessPage />} />
          <Route path="/rejected" element={<RejectedAccessPage />} />
          <Route path="*" element={<ProtectedRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;